const landingType = {
    LANDING_SERVICE_CALL: "LANDING_SERVICE_CALL",
    LANDING_SERVICE_CALL_COMMIT: "LANDING_SERVICE_CALL_COMMIT",
    LANDING_SERVICE_CALL_ROLLBACK: "LANDING_SERVICE_CALL_ROLLBACK",
};

export default landingType;